import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  planningStream: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/widget/vuex/index.js